<template>
  <div style="padding-bottom: 50px; overflow-y: auto;">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据测试</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="margin-top: 40px;">
      <!-- <el-button type="primary" @click="createBill">生成账单</el-button>
      <el-button type="primary" @click="createComputData">生成计算账单</el-button> -->
    </div>

    <div style="margin-top: 40px;">
      <p>生成当天的实时数据（根据当前部门的取值/每日或每15分钟）</p>
      <el-select v-model="createDataFrom.unit" placeholder="请选择" style="width: 120px;">
        <el-option label="日" value="日"></el-option>
        <el-option label="小时" value="小时"></el-option>
        <el-option label="分钟" value="分钟"></el-option>
      </el-select>
      <el-select v-model="createDataFrom.energyType" placeholder="请选择" style="width: 120px;">
        <el-option label="电" value="15"></el-option>
        <el-option label="水" value="16"></el-option>
      </el-select>
      <el-input placeholder="input cycle" v-model="createDataFrom.cycle" style="width: 200px;"></el-input>
      <el-button @click="createData" type="primary">生成数据</el-button>
    </div>
    <div style="margin-top: 40px;">
      <el-row>
        <el-col :span="6">
          <el-date-picker v-model="date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" @change='getRdate'>
          </el-date-picker>
          <el-button @click="getDayDate" :loading="loadDayData" type="primary">生成日用量</el-button>
        </el-col>

        <el-col :span="6">
          <el-date-picker v-model="dateMonth" type="month" placeholder="选择日期" value-format="yyyy-MM" @change="getYdate">
          </el-date-picker>
          <el-button @click="getMonthData" type="primary" :loading="loadMonthData">生成月用量</el-button>
        </el-col>
      </el-row>

    </div>



    <el-row style="margin-top: 40px;">
      <el-col :span="8">
        <p>生成每日能耗数据</p>
        <el-select v-model="dailyData.dayOrMonth" placeholder="请选择" style="width: 120px;">
          <el-option label="日" value="1"></el-option>
          <el-option label="月" value="2"></el-option>
        </el-select>
        <el-date-picker v-model="dailyData.date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
        </el-date-picker>
        <el-button type="primary" @click="createEnergyData()">确认</el-button>
      </el-col>

      <el-col :span="8">
        <p>刷新缓存（刷新redis）</p>
        <el-button type="primary" @click="Refresh()">确认</el-button>
      </el-col>


    </el-row>

    <el-row style="margin-top: 40px;">
      <el-col :span="8">
        <p>刷新能耗日历</p>
        <el-input placeholder="输入部门id" style="width: 100px;" v-model="riliForm.departmentId"></el-input>
        <el-date-picker v-model="riliForm.date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
        </el-date-picker>
        <el-button type="primary" @click="RefreshRili()">确认</el-button>
      </el-col>
    </el-row>

    <div style="margin-top: 40px;">
      <p>导入并初始化充值金额与低度数据（新开户时使用）</p>
      <el-row>
        <el-col :span="4">
          <el-upload action="" multiple :http-request="importData1" :show-file-list="false">
            <el-button type="primary" :loading="loadData1"> 初始化充值数据</el-button>
          </el-upload>
        </el-col>

        <el-col :span="4">
          <el-upload action="" multiple :http-request="importData2" :show-file-list="false">
            <el-button type="primary" :loading="loadData2">初始化底度数据</el-button>
          </el-upload>
        </el-col>
      </el-row>

    </div>
    <div style="margin-top: 40px;">

      <span>根据用户生成月账单: billdate-用户需要生成账单的日; username-用户名称; num-0.表示生成本月账单,-1.表示生成上月账单</span>
      <div style="margin-top: 20px;">
        <el-input style="width:200px;margin-right:10px" placeholder="用户需要生成账单的日" v-model="billForm.billDate"></el-input>
        <el-input style="width:200px;margin-right:10px" placeholder="用户名称" v-model="billForm.username"></el-input>
        <el-input style="width:200px;margin-right:10px" placeholder="账单类型" v-model="billForm.num"></el-input>
        <el-button type="primary" @click="createMonthBill" :loading="loadBill">生成月账单</el-button>
      </div>


    </div>

    <div style="margin-top: 40px;">
      <p>手动将win数据库中zdt_ele_bm中的数据放入es中(参数:cycle/采集参考时间,unit/采集周期类型 0：分钟 1：小时 2：日 )</p>
      <el-select v-model="unit">
        <el-option value="分钟" label="分钟"></el-option>
        <el-option value="小时" label="小时"></el-option>
        <el-option value="日" label="日"></el-option>
      </el-select>
      <el-button type="primary" @click="inputEsData" :loading="loadEs">数据入es库</el-button>
    </div>

    <div style="margin-top: 40px;">
      <p>初始化房间</p>
      <div>
        <el-input style="width: 200px;" placeholder="输入部门ID" v-model="depId"></el-input>
        <el-button type="primary" @click="initRoom" :loading="loadInit">确定</el-button>
      </div>

    </div>

    <div style="margin-top: 40px;">
      <p>计算水费物业费</p>
      <div>
        <el-input style="width: 200px;" placeholder="输入部门ID" v-model="jdepId"></el-input>
        <el-button type="primary" @click="conmputData" :loading="loadComput">确定</el-button>
      </div>

    </div>
    <div style="margin-top: 40px;">
      <p>南网演示数据召读</p>
      <div>

        <el-button type="primary" @click="zhaoduNw" :loading="loadNw">发送</el-button>
      </div>

    </div>
    <div style="margin-top: 40px;">

      <div>

        <el-button type="primary" @click="createZd" :loading="loadZd">生成年账单</el-button>
      </div>

    </div>
    <div style="margin-top: 40px;">

      <el-upload
      	action=""
      	multiple
      	:http-request="importData"
      	:show-file-list="false"
      	style="float: left;"
      >
      <el-button  icon="el-icon-upload2" type="primary"   :loading="loadLoadin"   > 租金导入</el-button>
      </el-upload>


       <el-button style="margin-left: 20px;" type="primary" @click="clickAddWalletRecharge" :loading="loadWalletRecharge">交易记录生成回执编号</el-button>

    </div>
  </div>
</template>

<script>
  import {
    generateMonthlyBill,
    generateESPowerData,
    calMeterInfoPrice
  } from '../../api/userMG.js'
  import {
    getDepartmentTerminalInfoLis
  } from '../../api/energyMG'
  import {
    energyDay,

    energyMonth,
    saveDailyEnergyRecord,
    flushRedis,
    redisEnergy,
    generateMonthlyBillByUser,
    getPowerDataFromLocal,
    initializeRoom,
    compute,
    callDateByTest,
    saveYearBill,
    uploadMeterRent,
    addWalletRecharge
  } from '../../api/dataMG.js'
  import {
    initData
  } from '../../api/userMG.js'
  export default {
    data() {
      return {
        loadZd:false,
        loadInit: false,
        loadWalletRecharge:false,
        jdepId: '',
        loadNw:false,
        loadComput: false,
        depId: "",
        deptList: [],
        loadEs: false,
        loadData1: false,
        loadData2: false,
        loading: false, //是显示加载
        loadDayData: false,
        loadBill: false,
        date: "",
        dateMonth: "",
        loadMonthData: false,
        dailyData: {
          dayOrMonth: '',
          date: ""
        },
        unit: "",
        riliForm: {
          departmentId: "",
          date: ""
        },
        billForm: {
          billDate: '',
          username: "",
          num: ""
        },
        createDataFrom: {
          cycle: '',
          unit: '日',
          energyType: '15'
        },
        loadLoadin:false
      }
    },

    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getJzData();
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {

      clickAddWalletRecharge(){
        this.loadWalletRecharge = true
        addWalletRecharge().then(res => {
          this.loadWalletRecharge = false
          if(res.status == 1){
            this.$message.success('操作成功')
          }else{
            this.$message.error(res.msg)
          }
        })
      },

      importData:function(val){
      	this.loadLoadin = true
      	let  formData = new FormData();
      	formData.append('file', val.file);
      	uploadMeterRent(formData).then( res=> {
      		this.loadLoadin = false
      		if(res.status == 1){
      			this.$message.success(res.msg)

      		}else{
      			this.$message.error(res.msg)
      		}
      	})
      },

      createZd(){
        this.loadZd = true
        saveYearBill().then(res => {
          this.loadZd = false
          if(res.status == 1){
            this.$
          }
        })
      },


      zhaoduNw(){

        callDateByTest().then(res => {
          this.loadNw = false
          if(res.status == 1){
            this.$message.success('操作成功！')

          }else{
            this.$message.error(res.msg)
          }
        })
      },

      getJzData: function() {

        getDepartmentTerminalInfoLis().then(res => {
          this.treeLoad = false
          if (res.status == 1) {

            this.deptList = res.data.menuDepList

          }

        })


      },

      conmputData() {
        this.loadComput = true
        compute({
          depId: this.jdepId
        }).then(res => {
          this.loadComput = false
          if (res.status == 1) {
            this.$message.success('操作成功！')
          } else {
            this.$message.error(res.msg)
          }
        })
      },

      initRoom() {
        this.loadInit = true
        initializeRoom({
          depId: this.depId
        }).then(res => {
          this.loadInit = false
          if (res.status == 1) {
            this.$message.success('操作成功！')
          } else {
            this.$message.error(res.msg)
          }
        })
      },

      inputEsData() {
        this.loadEs = true
        getPowerDataFromLocal().then(res => {
          this.loadEs = false
          if (res.status == 1) {
            this.$message.success('操作成功！')
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      createMonthBill() {
        this.loadBill = true
        generateMonthlyBillByUser(this.billForm).then(res => {
          this.loadBill = false
          if (res.status == 1) {
            this.$message.success(res.msg)

          } else {
            this.$message.error(res.msg)
          }
        })
      },

      importData1(val) {
        this.loadData1 = true

        let formData = new FormData();
        formData.append('file', val.file);
        formData.append('type', 1);
        initData(formData).then(res => {
          this.loadData1 = false
          if (res.status == 1) {
            this.$message.success(res.msg)
            //this.getdata();
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      importData2(val) {
        this.loadData2 = true
        let formData = new FormData();
        formData.append('file', val.file);
        formData.append('type', 2);
        initData(formData).then(res => {
          this.loadData2 = false
          if (res.status == 1) {
            this.$message.success(res.msg)
            //this.getdata();
          } else {
            this.$message.error(res.msg)
          }
        })
      },




      //生成计算账单
      createComputData() {

        calMeterInfoPrice().then(res => {
          if (res.status == 1) {
            this.$message.success('操作成功！')
            this.getData()
          }
        })
      },

      //生成账单
      createBill() {
        generateMonthlyBill().then(res => {
          if (res.status == 1) {
            this.$message.success('操作成功！')
            this.getData()
          }
        })
      },
      //生成数据
      createData() {

        generateESPowerData(this.createDataFrom).then(res => {
          if (res.status == 1) {
            this.$message.success('操作成功！')
          }
        })
      },

      getRdate(e) {
        this.date = e
      },
      getYdate(e) {
        this.dateMonth = e
      },

      //生成日用量
      getDayDate() {
        let param = {
          date: this.date
        }
        this.loadDayData = true
        energyDay(param).then(res => {
          this.loadDayData = false
          if (res.status == 1) {
            this.$message.success('操作成功')
          } else {
            this.$message.error('操作失败')
          }
        })
      },

      //生成月用量
      getMonthData() {
        let param = {
          date: this.dateMonth
        }
        this.loadMonthData = true
        energyMonth(param).then(res => {
          this.loadMonthData = false
          if (res.status == 1) {
            this.$message.success('操作成功')
          } else {
            this.$message.error('操作失败')
          }
        })
      },
      //生成每日能耗数据
      createEnergyData() {
        saveDailyEnergyRecord(this.dailyData).then(res => {
          if (res.status == 1) {
            this.$message.success('操作成功')
          } else {
            this.$message.error('操作失败')
          }
        })
      },
      //刷新缓存
      Refresh() {
        flushRedis().then(res => {
          if (res.status == 1) {
            this.$message.success('操作成功')
          } else {
            this.$message.error('操作失败')
          }
        })
      },
      //刷新能耗日历
      RefreshRili() {
        redisEnergy(this.riliForm).then(res => {
          if (res.status == 1) {
            this.$message.success('操作成功')
          } else {
            this.$message.error('操作失败')
          }
        })
      },



    }
  }
</script>

<style scoped>
  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/charts/dataTest.vue